module.exports = __webpack_public_path__ + "img/Menu-05.0b94ca3a.webp";